import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

@Component({
    selector: 'hierarchy-tile',
    templateUrl: './hierarchy-tile.component.html',
    styleUrls: ['./hierarchy-tile.component.scss'],
})
export class HierarchyTileComponent implements OnInit {
    constructor() {}

    @Input() hideEditIcon: boolean;
    @Input() tileName: string;
    @Input() description: string;
    @Input() fontIcon: string;
    @Input() fontSet: string;
    @Input() hideTitleIcon: boolean;
    @Input() activeShadow: string;
    @Output() editClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
    tileClass: string;
    tileIconClass: string;
    isEditClicked: boolean;

    ngOnInit() {
        this.isEditClicked = false;
        this.tileClass = 'middle-level-tile';
        this.tileIconClass = 'middle-level-icon';
        this.activeShadow = 'regular-shadow';
        this.trimDescription();

        if (this.hideTitleIcon && this.hideEditIcon) {
            this.tileClass = 'new-level-tile';
            this.tileIconClass = '';
            this.activeShadow = 'active-shadow';
        } else if (!this.hideTitleIcon && this.hideEditIcon) {
            this.tileClass = 'main-level-tile';
            this.tileIconClass = 'main-level-icom';
        } else if (
            !this.hideTitleIcon &&
            !this.hideEditIcon &&
            (!this.description || this.description.length === 0)
        ) {
            this.tileClass = 'middle-level-tile-no-description';
        }
    }

    trimDescription() {
        if (!this.description) {
            return null;
        }
        this.description = this.description.slice(0, 15);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.hideTitleIcon && !this.hideEditIcon) {
            if (!this.description || this.description.length === 0) {
                this.tileClass = 'middle-level-tile-no-description';
            } else {
                this.tileClass = 'middle-level-tile';
            }
        }

        this.trimDescription();
    }

    editIconClick() {
        this.isEditClicked = true;
        this.editClicked.emit(this.isEditClicked);
    }
}
